<template>
  <div class="mockup-preview-youtube-video">
    <slot name="stores"></slot>
    <div class="mockup__input">
      <label for="video-youtube">Youtube Link</label>
      <input
        v-model="current.previewYoutubeVideo.src"
        type="text"
        placeholder="https://www.youtube.com/embed/bH1iodXyXyk?si=GdX4-5hjbXvBEHlX"
        @input="setYoutubeVideo"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: { current: Object },
  data() {
    return {
      timestamp: new Date().getTime(),
    };
  },
  methods: {
    videoIsSquare(url) {
      return new Promise((resolve) => {
        let video = document.createElement("video");
        video.addEventListener(
          "loadedmetadata",
          () => resolve(video.videoWidth === video.videoHeight),
          false
        );
        video.src = url;
      });
    },
    setYoutubeVideo(e) {
      const src = e.target.value;
      if (!src) return;
      this.current.addPreviewYoutubeVideo({ src });
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-video {
  display: grid;
  padding: 0 6px 6px;
  gap: 6px;
}
</style>
